import { isScanBlockReason, type TaskDTO } from "@csp/shared";
import { api } from "../lib/api";
import { useAction, useLoad } from "../lib/hooks";
import { useDialog } from "./Dialogs";
import { extractionBlocked } from "./ExtractionPanel";

export function RecoveryControls({task,canAct,onChanged}: {task:TaskDTO;canAct:boolean;onChanged:()=>void}) {
  const act=useAction();
  const run = async (kind:string,fn:()=>Promise<unknown>)=>{if(await act.run(kind,fn)!==undefined)onChanged();};
  if(!canAct)return null;
  return <><button className="btn btn-primary" disabled={!!act.busy || !["blocked","waiting_scan"].includes(task.status)} onClick={()=>void run("resume",()=> task.status==="waiting_scan" || isScanBlockReason(task.blockReason) ? api.scanRestart(task.id) : api.resumeTask(task.id))}>{task.status==="waiting_scan" || isScanBlockReason(task.blockReason) ? "重新登录" : "从当前处继续"}</button>
    <RestartTaskButton task={task} onChanged={onChanged} />
    {act.error&&<span className="notice err">{act.error}</span>}
  </>;
}
export function RecoveryPoints({task,canAct,onChanged}: {task:TaskDTO;canAct:boolean;onChanged:()=>void}) {
  const points=useLoad(()=>api.recoveryPoints(task.id),[task.id,task.updatedAt]);const act=useAction();
  return <div className="card"><h2>已知卡点</h2><p className="muted small">保存的是恢复指引，不是浏览器快照。继续前会先核对页面；尚未验证的指引不视为已通过。</p>
    {points.data?.map(p=><div className="recovery-card" key={p.id}><h3>{p.name}<span className="pill">待验证</span></h3><p className="pre" translate="no">{p.sourceText}</p><p className="pre" translate="no">{p.instruction}</p><button className="btn" disabled={!canAct||task.status!=="blocked"||!!act.busy} onClick={()=>void act.run("resume",async()=>{await api.resumeTask(task.id,"",p.id);onChanged();return {ok:true};})}>从此卡点继续</button></div>)}
    {!points.data?.length&&<div className="empty">点击右侧事件，选择“设为已知卡点”</div>}{(points.error||act.error)&&<p className="notice err">{points.error||act.error}</p>}
  </div>;
}

/** 可以「重新开始任务」的状态（与后端 engine.restart 一致） */
export const RESTARTABLE = ["running","waiting_scan","review_required","blocked","ready","queued","failed"];

/** 重新开始任务：结束当前运行、保留历史和材料，按最新材料和提取结果从第一步重跑；提取中 / 缺字段时不可点 */
export function RestartTaskButton({task,onChanged,primary=false}: {task:TaskDTO;onChanged:()=>void;primary?:boolean}) {
  const act=useAction();const dialog=useDialog();
  const blocked=extractionBlocked(task);
  if(!RESTARTABLE.includes(task.status))return null;
  const go=async()=>{
    if(!await dialog.confirm({title:"重新开始这个任务？",body:<p>结束当前运行，保留历史和材料，按最新的材料和提取到的信息从第一步重新运行。</p>,okText:"重新开始"}))return;
    if(await act.run("restart",()=>api.restartTask(task.id))!==undefined)onChanged();
  };
  return <><button className={`btn${primary?" btn-primary":""}`} data-testid="restart-task" disabled={!!act.busy || !!blocked} title={blocked ?? undefined} onClick={()=>void go()}>{act.busy?"正在重新开始…":"重新开始任务"}</button>
    {act.error&&<span className="notice err">{act.error}</span>}</>;
}
